"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDataPath = void 0;
function parseDataPath(value) {
    // HACK: This function doesn't handle brackets, so we convert
    // brackets to dot ("foo['bar']" => "foo.bar")
    // Fixed in later commit: https://github.com/grantila/awesome-ajv-errors/commit/2bb692f7333fb8746b294c795c79a9f1dcf2d2a4
    // but we can't update to the fixed version because it's only published
    // as an ESM module
    value = value.replace(/\['(.*?)'\]/g, '.$1');
    const path = [].concat(...value
        .split('.')
        .map(entry => entry
        .split(/\[|\]/g)
        .map((key, index) => ({
        key,
        type: index === 0 ? 'string' : 'number'
    }))))
        .filter(val => val.key !== '');
    const dotOnly = '.' + path.map(({ key }) => key).join('.');
    return { orig: value, dotOnly, path };
}
exports.parseDataPath = parseDataPath;
